import React from 'react';
import { SvgIcon } from '@mui/material';
const SvgCrossGreen = (props) => (
  <SvgIcon {...props} title="CrossGreen">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 12"
      style={{
        enableBackground: 'new 0 0 14 12'
      }}
      xmlSpace="preserve"
      {...props}
    >
      <path
        style={{
          fill: '#017163'
        }}
        d="M2.8 12 7 7.8l4.2 4.2 1.8-1.8L8.8 6 13 1.8 11.2 0 7 4.2 2.8 0 1 1.8 5.2 6 1 10.2z"
      />
    </svg>
  </SvgIcon>
);
export default SvgCrossGreen;
